import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//Material
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
//Icons
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';

//Para consultas
import gql from 'graphql-tag';
import { useMutation, useLazyQuery } from '@apollo/react-hooks';
//DS
import LoadingModal from '../../moleculas/LoadingModal';
import DialogDS from '../../moleculas/DialogDS';
import Sidebar from '../../atomicos/Sidebar/Sidebar';
//import SpeedDialDS from '../atomicos/SpeedDialDS';
import DialogBase from '../../atomicos/DialogBase';
import { generarConsulta } from '../../../common/helpers';
import { showError, showSucces } from '../../../common/toast'
//DEFAULTS
import { defaults, cadenas, validacion } from 'lib.common';

const { funcionVacia, objetoVacio } = defaults;
const { tienePropVacia, esVarNullUndef, objetoNoVacio } = validacion;
const { primeraLetraMayus } = cadenas;

const useStyles = makeStyles((theme) => ({
   root: {
      opacity: 1,
      position: 'relative',
      flexGrow: 1,
      widht: '100%',
      //height: "100%",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
   },
   container: {
      transform: 'translateZ(0px)',
      display: 'flex',
      flexWrap: 'wrap',
      widht: '100%'
      //height: "100%",
   },
   dense: {
      marginTop: theme.spacing(2)
   },
   button: {
      margin: theme.spacing(1)
   },
   marginL: {
      marginLeft: theme.spacing(1)
   },
   containerTitulo: {
      borderDownStyle: 'solid',
      borderColor: theme.palette.primary,
      backgroundColor: theme.palette.secondary
   },
   fabEliminar: {
      color: theme.palette.text.secondary,
      '&:hover': {
         backgroundColor: theme.palette.danger ? theme.palette.danger.main : theme.palette.error
      },
      transition: `${theme.transitions.create('transform', {
         duration: theme.transitions.duration.shorter
      })}, opacity 0.8s`,
      opacity: 1
   },
   invisible: {
      display: 'none'
   }
}));

/**
 * Estados iniciales
 */
const msgModalInicial = {
   open: false,
   mensaje: '',
   accionAceptar: null,
   aceptarLabel: 'Eliminar'
};

const modoProcesoInicial = {
   actualizando: false,
   procesando: false
};

/**
 * Funciones y variables estaticas
 */
const dummyQuery = gql`
   mutation Error($codigo: String!) {
      error(codigo: $codigo)
   }
`;

const esOkDefault = { ok: true, mensaje: 'Operación realizada exitosamente.' };

/**
 * Componente para facilitar la construccion de formularios con operaciones CRUD basicas para tablas simples.
 */
function Base(props) {
   const { clave: ClaveComponent } = props;
   /**
    * Estados de control
    */
   const [modoProceso, setModoProceso] = useState(modoProcesoInicial);
   const [msgModal, setMsgModal] = useState(msgModalInicial);

   /**
    * Estado y efectos para generar las queries.
    */
   const [qRecuperar, setQRecuperar] = useState('');
   const [qActualizar, setQActualizar] = useState('');
   const [qAgregar, setQAgregar] = useState('');
   const [qEliminar, setQEliminar] = useState('');

   useEffect(() => {
      if (!qActualizar || !qAgregar || !qEliminar || !qRecuperar) {
         asignarQueries();
      }
   }, []);

   async function asignarQueries() {
      const ActualizarQ = await generarQuery('actualizar');
      const AgregarQ = await generarQuery('agregar');
      const EliminarQ = await generarQuery('eliminar');
      const RecuperarQ = await generarQuery('recuperar');
      setQActualizar(ActualizarQ);
      setQAgregar(AgregarQ);
      setQEliminar(EliminarQ);
      setQRecuperar(RecuperarQ);
   }
   /**
    * Handlers
    */
   //Modo de proceso
   const procesando = (valor) => {
      setModoProceso({ ...modoProceso, procesando: valor });
   };
   const actualizando = (valor) => {
      setModoProceso({ ...modoProceso, actualizando: valor });
   };
   //SnacBar
   const handleOpenSuccesMsg = (nuevoMsg) => {
      if (props.mostrarMensajeExito) {
         props.mostrarMensajeExito(nuevoMsg);
      } else {
         toast.show
      }
   };
   //Modal
   const handleClose = () => {
      setMsgModal(msgModalInicial);
   };
   const handleOpen = (nuevoMsg) => {
      setMsgModal({ ...msgModal, open: true, mensaje: nuevoMsg });
   };
   const handleEliminarOpen = () => {
      setMsgModal({
         open: true,
         mensaje: 'Esta seguro que desea eliminar el registro?',
         accionAceptar: procesarEliminar,
         aceptarLabel: 'Eliminar'
      });
   };

   /**
    * Inicializar funciones y variables enviadas por propiedades
    */
   const setDisabled = (disabled) => {
      if (props.setDisabled) {
         props.setDisabled(disabled);
      }
   };
   function handleCloseModal() {
      if (props.handleCloseModal) {
         props.handleCloseModal();
         inicializar();
      }
   }
   function inicializar() {
      if (props.inicializar) {
         props.inicializar();
      }
      //handleCloseModal();
      setDisabled(false);
      setModoProceso(modoProcesoInicial);
   }
   const esInputOk = async () => {
      let resultado = {
         ok: false,
         msg:
            'Ha sucedido un error al momento de validar los datos.\nPor favor verifique que la información ingresada sea correcta'
      };
      if (typeof props.existeErrorInput !== 'undefined') {
         if (!props.existeErrorInput && props.validarTodos !== undefined) {
            resultado.ok = await props.validarTodos();
            return resultado;
         } else {
            resultado.ok = !props.existeErrorInput;
            return resultado;
         }
      }
      if (props.esInputOk) {
         return await props.esInputOk();
      }
      resultado.ok = true;
      resultado.msg = '';
      return resultado;
   };

   const procesarAntesGrabar = () => {
      let resultado = {
         ok: false,
         msg: 'Ha sucedido un error al verificar los datos a grabar'
      };
      if (props.procesarAntesGrabar) {
         return props.procesarAntesGrabar();
      }
      resultado.ok = true;
      resultado.msg = '';
      return resultado;
   };

   /**
    * Genera una query GraphQL dependiendo del `proceso`
    * @param {String} proceso Tipo de proceso para el cual se genera la query. Puede tomar valores: 'recuperar', 'agregar' ,'eliminar' y 'actualizar'
    */
   async function generarQuery(proceso) {
      let query = props.entidad;
      let operacion = '';
      let nombreQuery = await primeraLetraMayus(query);
      let resultadoCadena = false;
      switch (proceso) {
         case 'recuperar':
            if (props.queryRecuperar) {
               query = props.queryRecuperar;
            }
            operacion = 'query';
            break;
         case 'agregar':
            if (props.queryAgregar) {
               query = props.queryAgregar;
            } else {
               query = 'agregar' + nombreQuery;
            }
            operacion = 'mutation';
            resultadoCadena = props.mutacionCadena;
            break;
         case 'eliminar':
            if (props.queryEliminar) {
               query = props.queryEliminar;
            } else {
               query = 'eliminar' + nombreQuery;
            }
            operacion = 'mutation';
            resultadoCadena = props.mutacionCadena;
            break;
         case 'actualizar':
            if (props.queryActualizar) {
               query = props.queryActualizar;
            } else {
               query = 'actualizar' + nombreQuery;
            }
            operacion = 'mutation';
            resultadoCadena = props.mutacionCadena;
            break;
      }
      return await generarConsulta(props.campos, operacion, query, proceso, resultadoCadena);
   }
   /**
    * Separa los parametros proporcionados al componente dependiendo del `flag`
    * @param {String} flag Determina que parametros se generaran puede tomar valores:
    * 'paramRecuperarEliminar', 'paramAgregar', 'paramActualizar'
    * @returns Conjunto de parametros dependiendo del flag que tengan activo.
    */
   async function generarParametros(flag) {
      const paramAll = await props.generarParametros();
      let param = {};
      await props.campos.forEach((campo) => {
         if (campo[flag]) {
            if (paramAll[campo.nombre] !== undefined && paramAll[campo.nombre] !== null) {
               param[campo.nombre] = paramAll[campo.nombre];
            }
         }
      });
      return param;
   }
   //Funciones para grabar
   const procesarDespuesGrabar = props.procesarDespuesGrabar;
   //Funciones para eliminar
   const esOkEliminar = props.esOkEliminar
      ? props.esOkEliminar
      : () => {
         return esOkDefault;
      };

   const asignarValoresEstados = props.asignarValoresEstados;
   /**
    * Inicialación Queries
    */
   const queryAgregar = qAgregar ? gql(qAgregar) : dummyQuery;
   const queryActualizar = qActualizar ? gql(qActualizar) : dummyQuery;
   const queryEliminar = qEliminar ? gql(qEliminar) : dummyQuery;
   //const queryRecuperar = gql(props.queryRecuperar);
   const queryRecuperar = qRecuperar ? gql(qRecuperar) : dummyQuery;
   /*
    HOOKS
    */
   const classes = useStyles();
   const [procesar, { loading: loadingP, error: errorP, data: dataP }] = useMutation(
      modoProceso.actualizando ? queryActualizar : queryAgregar
   );
   const [eliminar, { loading: loadingE, error: errorE, data: dataE }] = useMutation(queryEliminar);
   const [recuperar, { loading: loadingQ, error: errorQ, data: dataQ }] = useLazyQuery(
      queryRecuperar
   );

   /**
    * Efectos Errores
    */
   useEffect(() => {
      let eMsg = '';
      if (!esVarNullUndef(errorE)) {
         eMsg = JSON.stringify(errorE);
      }
      if (!esVarNullUndef(errorQ)) {
         eMsg = JSON.stringify(errorQ);
      }
      if (!esVarNullUndef(errorP)) {
         eMsg = JSON.stringify(errorP);
      }
      if (eMsg !== '') {
         if (eMsg.includes('1451-Cannot delete or update a parent row')) {
            handleOpen('No se puede eliminar, porque está siendo utilizado en otro módulo.');
         } else {
            handleOpen(eMsg);
         }
      }
   }, [errorE, errorQ, errorP]);

   function initDespuesProcesar(msg) {
      inicializar();
      setDisabled(false);
      if (msg.length > 0) {
         handleOpen(msg);
      } else {
         handleOpenSuccesMsg('Operación realizada correctamente');
      }
      handleCloseModal();
   }
   /**
    * Efectos eliminar
    */
   useEffect(() => {
      if (!esVarNullUndef(dataE)) {
         const dataAux = dataE[Object.keys(dataE)[0]];
         if (dataAux != null) {
            handleClose();
            initDespuesProcesar(dataAux);
         }
      }
   }, [dataE]);
   /**
    * Efectos procesar
    */
   useEffect(() => {
      if (!esVarNullUndef(dataP)) {
         const dataAux = dataP[Object.keys(dataP)[0]];
         if (dataAux != null) {
            procesarDespuesGrabar(dataAux);
            initDespuesProcesar(dataAux);
         }
      }
   }, [dataP]);
   /**
    * Efectos Query
    */

   useEffect(() => {
      let updt = false;
      if (!esVarNullUndef(dataQ)) {
         const dataAux = dataQ[Object.keys(dataQ)[0]];
         if (dataAux != null) {
            if (Array.isArray(dataAux) && dataAux.length > 0) {
               asignarValoresEstados(dataAux[0]);
            } else {
               asignarValoresEstados(dataAux);
            }
            updt = true;
         } else {
            updt = false;
         }
         setDisabled(true);
      }
      actualizando(updt);
   }, [dataQ]);

   useEffect(() => {
      if (qRecuperar && props.llamarRecuperar) {
         procesarRecuperar();
      }
   }, [props.llamarRecuperar, qRecuperar]);
   /**
    * Funciones
    */
   const procesarGrabar = async () => {
      const input = await esInputOk();
      if (input.ok) {
         const okGrabar = await procesarAntesGrabar();
         if (okGrabar.ok) {
            let param = {};
            if (modoProceso.actualizando) {
               param = await generarParametros('paramActualizar');
            } else {
               param = await generarParametros('paramAgregar');
            }
            if (objetoNoVacio(param)) {
               procesar({ variables: param });
            }
         } else {
            handleOpen(okGrabar.msg);
         }
      } else {
         props.mostrarMensajeError(input.msg);
      }
   };

   const procesarEliminar = async () => {
      let okEliminar = await esOkEliminar();
      if (okEliminar.ok) {
         const params = await generarParametros('paramRecuperarEliminar');
         if (objetoNoVacio(params)) {
            eliminar({
               variables: params
            });
         }
      } else {
         handleOpen(okEliminar.msg);
      }
   };

   const procesarRecuperar = async () => {
      const claves = await generarParametros('paramRecuperarEliminar');
      if (objetoNoVacio(claves) && !tienePropVacia(claves)) {
         recuperar({ variables: claves });
         procesando(true);
      }
   };

   //Eventos
   const onBlur = () => {
      procesarRecuperar();
   };

   /**
    * Componentes auxiliares
    */

   /**
    * Objetos internos
    */
   useEffect(() => {
      if (props.primerFocoDespuesRecuperar && (modoProceso.actualizando || modoProceso.procesando)) {
         props.primerFocoDespuesRecuperar();
      }
   }, [modoProceso])
   return (
      <div id="fmBase" className={clsx(classes.root,props.className)}>
         <Grid container className={classes.container}>
            <Grid container item className={classes.containerTitulo}>
               <Grid item xs={11}>
                  <Typography variant="h4" gutterBottom>
                     {props.titulo.toUpperCase()}
                  </Typography>
               </Grid>
               <Grid item xs={1}>
                  {typeof props.open !== 'undefined' && (
                     <IconButton aria-label="close" onClick={handleCloseModal}>
                        <CloseIcon />
                     </IconButton>
                  )}
               </Grid>
            </Grid>
            <Grid container item>
               {/*<Grid item xs={12} onBlur={onBlur}>*/}
               <Grid container item xs={12}>
                  <ClaveComponent onBlur={onBlur} />
                  <IconButton aria-label="close" onClick={onBlur} className={classes.marginL}>
                     <SearchIcon />
                  </IconButton>
               </Grid>
               <Divider />
               <Grid container item xs={12}>
                  {props.children}
               </Grid>
               <Divider />
               <Grid container item xs={12} justify="flex-end">
                  <Button
                     variant="contained"
                     color="primary"
                     className={clsx(classes.button, {
                        [classes.invisible]: props.procesarNoVisible
                     })}
                     startIcon={modoProceso.actualizando ? <RefreshIcon /> : <SaveIcon />}
                     onClick={procesarGrabar}
                     disabled={
                        (typeof props.existeErrorInput !== 'undefined' && props.existeErrorInput) ||
                        (!modoProceso.actualizando && !modoProceso.procesando)
                     }
                  >
                     {modoProceso.actualizando ? 'Actualizar' : 'Grabar'}
                  </Button>
                  <Button
                     variant="contained"
                     color="secondary"
                     className={clsx(classes.button, classes.fabEliminar, {
                        [classes.invisible]: props.eliminarNoVisible
                     })}
                     startIcon={<DeleteIcon />}
                     onClick={handleEliminarOpen}
                     disabled={!modoProceso.actualizando}
                  >
                     Eliminar
                  </Button>
                  {typeof props.open !== 'boolean' && (
                     <Button
                        variant="contained"
                        color="default"
                        className={clsx(classes.button, {
                           [classes.invisible]: props.cancelarNoVisible
                        })}
                        startIcon={<CancelIcon />}
                        onClick={inicializar}
                     >
                        Cancelar
                     </Button>
                  )}
               </Grid>
            </Grid>
         </Grid>
         <LoadingModal open={loadingE || loadingP || loadingQ} />
         <DialogDS titulo="Aviso" onClose={handleClose} {...msgModal}></DialogDS>
      </div>
   );
}

function FmBase(props) {
   function handleCloseModal() {
      if (props.handleCloseModal) {
         props.handleCloseModal();
      }
   }
   if (props.handleCloseModal) {
      if (props.tipoModal === 'sidebar') {
         <Sidebar open={props.open} onClose={handleCloseModal} {...props.modalProps}>
            <Base {...props} />
         </Sidebar>;
      } else {
         return (
            <DialogBase open={props.open} onClose={handleCloseModal} {...props.modalProps}>
               <Base {...props} />
            </DialogBase>
         );
      }
   } else {
      return <Base {...props} />;
   }
}

FmBase.propTypes = {
   /**
    * Texto a mostrar en la cabecera del formulario.
    */
   titulo: PropTypes.string,
   /**
    * Componente funcional que representan la clave del formulario.
    */
   clave: PropTypes.func.isRequired,
   /**
    * Componente o componentes que forman la interfaz del formulario y representan la informacion a mostrar y completar para guardar, actualizar o eliminar.
    */
   children: PropTypes.node.isRequired,
   /**
    * Entidad a la que estara relacionada el mantenimiento, si no se proporciona
    * queryRecuperar se usara esta propiedad como nombre de la consulta para la
    * recuperacion de datos.
    */
   entidad: PropTypes.string.isRequired,
   /**
    * Funcion encargada de habilidar y deshabilitar los componentes cuando se deja el contenedor de la clave. Debe aceptar un parametro booleano.
    */
   setDisabled: PropTypes.func,
   /**
    * Funcion encargada de limpiar el contenido de los estados al inicializar el formulario o al presionar cancelar. No acepta parametros.
    */
   inicializar: PropTypes.func,
   /**
    * Representa si existe algun error en los estados del input. Si es verdadero significa un error en los estados del input y bloquea las opciones de grabar, actualizar y eliminar.
    */
   existeErrorInput: PropTypes.bool,
   /**
    * Funcion de verificacion personalizada del input, toma precedencia sobre existeErrorInput. No acepta parametros, debe retornar un objeto con la forma {ok: boolean, msg: string} donde msg representa el mensaje de error a mostrar y si ok es false significa que existe un error en el input.
    */
   esInputOk: PropTypes.func,
   /**
    * Funcion para realizar procesos o acciones necesarias antes de grabar, se ejecuta despues de esInputOk. No acepta parametros, debe retornar un objeto con la forma {ok: boolean, msg: string} donde msg representa el mensaje de error a mostrar y si ok es false significa que sucedio un error en la funcion y se detiene el proceso de grabado.
    */
   procesarAntesGrabar: PropTypes.func,
   /**
    * Arreglo con la informacion de los campos a usar en las queries y mutaciones.
    * Se debe especificar el `nombre` de cada campo, su tipo de dato `tipoDato`, Si es usado en como parte de la respuesta del servidor `usarEnRespuesta`, si debe usarse como parametro en las consultas para recuperar y eliminar `paramRecuperarEliminar`, si debe usarse como parametro en la consulta para agergar `paramAgregar`, si debe usarse como parametro en las consultas para actualizar `paramActualizar`. En caso de necesitar anidar campos en la consulta agregar en `nombreRecuperar`.
    */
   campos: PropTypes.arrayOf(
      PropTypes.shape({
         nombre: PropTypes.string.isRequired,
         tipoDato: PropTypes.string.isRequired,
         usarEnRespuesta: PropTypes.bool.isRequired,
         paramRecuperarEliminar: PropTypes.bool.isRequired,
         paramAgregar: PropTypes.bool.isRequired,
         paramActualizar: PropTypes.bool.isRequired,
         nombreRecuperar: PropTypes.string
      })
   ).isRequired,
   /**
    * Nombre de la consulta GraphQl a usar para recuperar datos.
    */
   queryRecuperar: PropTypes.string,
   /**
    * Nombre de la mutacion GraphQl a usar al momento de grabar los datos. En caso de no
    * ser proporcionado se usara addEntidad como mutacion para esta operacion.
    */
   queryAgregar: PropTypes.string,
   /**
    * Nombre de la mutacion GraphQl a usar al momento de actualizar los datos. En caso de no
    * ser proporcionado se usara updateEntidad como mutacion para esta operacion.
    */
   queryActualizar: PropTypes.string,
   /**
    * Nombre de la mutacion GraphQl a usar al momento de eliminar los datos. En caso de no
    * ser proporcionado se usara removeEntidad como mutacion para esta operacion.
    */
   queryEliminar: PropTypes.string,
   /**
    * Funcion usada para generar los valores de los parametros de las consultas. No acepta parametros y debe retornar un objeto cuyas propiedades tienen como clave el campo correpondiente de la consulta GraphQl y su valor correspondiente.
    */
   generarParametros: PropTypes.func.isRequired,
   /**
    * Funcion para mapear los datos recuperados de la entidad a los estados correpondientes en el componente padre de FmBase. Debe aceptar un parametro objeto con la forma del resultado de la consulta usada para recuperar informacion, `entidad` o `queryRecuperar`.
    */
   asignarValoresEstados: PropTypes.func.isRequired,
   /**
    * Funcion de verificacion para la eliminacion de informacion. Debe retornar un objeto con la forma {ok: boolean, msg: string} donde msg representa el mensaje de error a mostrar y si ok es false significa que no se puede eliminar la informacion en pantalla.
    */
   esOkEliminar: PropTypes.func,
   /**
    * Funcion usada para realizar acciones despues de grabar. Acepta un parametro con el resultado de la mutacion usada para grabar información. Esta en version beta por lo que puede no comportarse de la manera especificada.
    */
   procesarDespuesGrabar: PropTypes.func,
   /**
    * Si es true, las mutaciones retornan textos como respuesta.
    */
   mutacionCadena: PropTypes.bool,
   /**
    * Funcion llamada para mostrar mensajes de exito, toma como parametro el mensaje generado.
    */
   mostrarMensajeExito: PropTypes.func,
   /**
    * Funcion llamada para mostrar mensajes de error, toma como parametro el mensaje generado.
    */
   mostrarMensajeError: PropTypes.func,
   /**
    * Indica el tipo de modal que se usara.
    */
   tipoModal: PropTypes.oneOf(['sidebar', 'dialogbase']),
   /**
    * Si es __true__, el componente funcionara dentro de un `DialogBase` e indicara si el modal esta abierto.
    */
   open: PropTypes.bool,
   /**
    * Callback ejecutado cuando el componente se cierre.
    */
   handleCloseModal: PropTypes.func,
   /**
    * Propiedades recibidas por `DialogBase`
    */
   modalProps: PropTypes.object
};

FmBase.defaultProps = {
   generarParametros: objetoVacio,
   procesarDespuesGrabar: funcionVacia,
   asignarValoresEstados: funcionVacia,
   open: undefined,
   procesarNoVisible: false,
   cancelarNoVisible: false,
   eliminarNoVisible: false,
   mostrarMensajeExito: showSucces,
   mostrarMensajeError: showError,
   tipoModal: 'dialogbase'
};

export default FmBase;
